// The shape of a class board as the game server sends it (src/game/boardCore.ts studentLessons; the teacher edits it
// on the teacher side's Board page).

export interface Lesson {
  date: string; // YYYY-MM-DD, Japan time
  title: string;
  notes?: string;
  due?: string; // what to hand in on Loilo Note
  quiz?: true | string; // true: this entry is a quiz or test; a name: a quiz held in this lesson
  kind?: 'exam'; // the exam row written across the whole week (the term's finals)
  links?: { label: string; href: string }[];
}

export interface Material {
  title: string;
  kind: string;
  added: string; // YYYY-MM-DD
  href?: string;
}

export interface Unit {
  name: string;
  materials: Material[];
}

export interface ClassBoard {
  id: string; // section, e.g. 6-1-s
  name: string; // e.g. 6-1 S
  course: string; // e.g. Logic and Expressions III (S)
  lessons: Lesson[];
  units: Unit[];
  slimeOnly?: true; // a class made on the host screen: no board yet, so its students see only the Slime tab
  hidden?: true; // the teacher took the schedule off the board for now: no dates, "Dates coming soon."
}

export const LOILO_URL = 'https://n.loilo.tv/';
